"use client";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import rehypeSanitize from "rehype-sanitize";
import { cn } from "@/lib/utils";

interface NewsMarkdownRendererProps {
  content: string;
  className?: string;
  allowImages?: boolean;
}

/**
 * Shared markdown renderer for news content
 * Ensures consistent rendering across all news views:
 * - Editor preview
 * - Public news page
 * - News modals
 * - Admin preview
 *
 * Features:
 * - GitHub-flavored markdown (tables, strikethrough, etc.)
 * - Line breaks on single newlines
 * - Paragraph spacing on double newlines
 * - Images, links, headers, bold, italic, lists, code blocks
 * - Sanitized HTML output for security
 */
export function NewsMarkdownRenderer({
  content,
  className,
  allowImages,
}: NewsMarkdownRendererProps) {
  return (
    <div
      className={cn(
        "prose prose-invert max-w-none [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:my-1",
        className
      )}
    >
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeSanitize]}
        {...(allowImages === false ? { components: { img: () => null } } : {})}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
